import { default as clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => {
    return clsx(inputs);
};
export const twCn = (...inputs: ClassValue[]) => {
    return twMerge(cn(inputs));
};
